import { render, staticRenderFns } from "./AppointmentPurpose.vue?vue&type=template&id=1584f8b7"
import script from "./AppointmentPurpose.vue?vue&type=script&lang=js"
export * from "./AppointmentPurpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports